<template>
  <div>
    <b-overlay
      :show="loading"
      rounded
      opacity="1"
      spinner-small
      spinner-variant="primary"
    >
      <div style="min-height: 400px;">
        <div>
          <div class="form-row" v-if="!loading && !allEmpty">
            <div class="form-group col-md-3">
              <label class="sm-label">Страны загрузки</label>
              <b-form-input
                v-model="searchUploading"
                placeholder="Введите запрос..."
                size="sm"
                class="mb-3"
              ></b-form-input>
              <b-list-group>
                <b-list-group-item
                  v-for="item in filteredUploadingGeography"
                  :key="`ug_${item.id}`"
                >{{ item.name }}</b-list-group-item>
                <p v-if="filteredUploadingGeography.length == 0">Не указано.</p>
              </b-list-group>
            </div>
            <div class="form-group col-md-3">
              <label class="sm-label">Страны разгрузки</label>
              <b-form-input
                v-model="searchUnloading"
                placeholder="Введите запрос..."
                size="sm"
                class="mb-3"
              ></b-form-input>
              <b-list-group>
                <b-list-group-item
                  v-for="item in filteredUnloadingGeography"
                  :key="`ung_${item.id}`"
                >{{ item.name }}</b-list-group-item>
                <p v-if="filteredUnloadingGeography.length == 0">Не указано.</p>
              </b-list-group>
            </div>
            <div class="form-group col-md-3">
              <label class="sm-label">Доступен транзит</label>
              <b-form-input
                v-model="searchTransit"
                placeholder="Введите запрос..."
                size="sm"
                class="mb-3"
              ></b-form-input>
              <b-list-group>
                <b-list-group-item
                  v-for="item in filteredTransitDirections"
                  :key="`td_${item.id}`"
                >{{ item.name }}</b-list-group-item>
                <p v-if="filteredTransitDirections.length == 0">Не указано.</p>
              </b-list-group>
            </div>
            <div class="form-group col-md-3">
              <label class="sm-label">Направления (относительно РФ)</label>
              <b-form-input
                v-model="searchRf"
                placeholder="Введите запрос..."
                size="sm"
                class="mb-3"
              ></b-form-input>
              <b-list-group>
                <b-list-group-item
                  v-for="item in filteredRfDirections"
                  :key="`rfd_${item.id}`"
                >{{ item.name }}</b-list-group-item>
                <p v-if="filteredRfDirections.length == 0">Не указано.</p>
              </b-list-group>
            </div>
          </div>
          <template v-if="!loading && allEmpty">
            <b-jumbotron header-level="5" header="Данные по географии не заполнены" lead="У компании не указана география деятельности. Отредактируйте карточку компании."></b-jumbotron>
          </template>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: {
    companyId: { type: Number, required: false, default: -1 },
    uploading_geography: { type: Array, default: () => [] },
    unloading_geography: { type: Array, default: () => [] },
    transit_directions: { type: Array, default: () => [] },
    rf_directions: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      searchUploading: '',
      searchUnloading: '',
      searchTransit: '',
      searchRf: ''
    };
  },
  computed: {
    allEmpty() {
      return (this.uploading_geography.length == 0 && 
              this.unloading_geography.length == 0 && 
              this.transit_directions.length == 0 && 
              this.rf_directions.length == 0);
    },
    filteredUploadingGeography() {
      return this.filterItems(this.uploading_geography, this.searchUploading);
    },
    filteredUnloadingGeography() {
      return this.filterItems(this.unloading_geography, this.searchUnloading);
    },
    filteredTransitDirections() {
      return this.filterItems(this.transit_directions, this.searchTransit);
    },
    filteredRfDirections() {
      return this.filterItems(this.rf_directions, this.searchRf);
    }
  },
  methods: {
    filterItems(items, searchTerm) {
      if (searchTerm.length < 2) {
        return items;
      }
      return items.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
  }
};
</script>
<style scoped>
.sm-label {
  font-size: 12px;
  line-height: 13px;
  font-weight: bold;
  border-bottom: 1px solid #CCCCCC;
  padding-bottom: 5px;
}
</style>
